import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import NavigationPage, { getDefaultPageUI } from "components/pages/NavigationPage";
import Classes, { Account } from "model";

export default function CaptureMabiMenuAccordionCheckingDetails(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "modal", "id" ], "MobileAccountDetailsModal")
        .update([ "modal", "data" ], checkingAccount)
        .submit();

    return <NavigationPage ui={ ui } />
}